import { render, staticRenderFns } from "./GMBAttributes.vue?vue&type=template&id=4205bad6&scoped=true"
import script from "./GMBAttributes.vue?vue&type=script&lang=js"
export * from "./GMBAttributes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4205bad6",
  null
  
)

export default component.exports